/* The gallery-stage script. Built by tools/build-assets.mjs from the review set; edit the review set, not this file. */
/* XGO web: the live packages page script, 2026-09-17 capture. Two edits only: short ids, and figures of 1,000 and over carry a separator. */

(function () {
  var root = document.documentElement;
  if (!root || root.dataset.xgoGalleryStage) return;
  root.dataset.xgoGalleryStage = '1';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO  = 'IntersectionObserver' in window;
  var SENS   = { yes: 'Yes', opt: 'Optional', na: 'Not fitted' };
  /* ---------- the gallery: a stage over a rail ----------
     The stage is a strip of the set's photographs, one to a frame, scroll-snapped: a finger swipes it as it swipes anything on a
     phone, with the browser's own momentum and snap, and a trackpad does the same. A thumbnail, or the arrow keys with the strip
     in focus, move it too. The rail scrolls sideways under a finger where it holds more thumbnails than it shows, and keeps the
     chosen one in view. Every gallery on the page: the product page's, the packages page's platform (its set changes with the
     vehicle: render() hands it the new one) and the Playbook's.
     The strip runs on (Dan, 14 October: a gallery never stops at its end), as the photograph viewer's does: a copy of the last
     photograph stands before the first and a copy of the first after the last, and where a swipe comes to rest on a copy the
     strip moves, with no animation, to the photograph it copies, the same picture in the same place. */
  function gallery(g) {
    var main = g.querySelector('[data-pgal-main]'), grail = g.querySelector('[data-pgal-rail]');
    if (!main) return null;
    var strip = document.createElement('div');
    strip.className = 'ti-pgal__strip';
    strip.tabIndex = 0;
    strip.setAttribute('aria-label', 'Photographs: swipe, or use the arrow keys');
    var cur = 0, aim = -1, ticking = false, rest = 0;
    var w = function () { return strip.clientWidth || 1; };
    var off = function () { return strip.firstElementChild && strip.firstElementChild.hasAttribute('data-copy') ? 1 : 0; };
    var count = function () { return strip.children.length - 2 * off(); };
    var to = function (p) { try { strip.scrollTo({ left: p * w(), behavior: 'instant' }); } catch (e) { strip.scrollLeft = p * w(); } };
    var loop = function () {
      if (strip.children.length < 2) return;
      var a = strip.firstElementChild.cloneNode(true), z = strip.lastElementChild.cloneNode(true);
      [a, z].forEach(function (c) { c.setAttribute('data-copy', ''); c.setAttribute('aria-hidden', 'true'); c.removeAttribute('id'); c.alt = ''; c.removeAttribute('fetchpriority'); c.loading = 'lazy'; });
      strip.appendChild(a);
      strip.insertBefore(z, strip.firstElementChild);
    };
    /* at rest on a copy: to the photograph it copies */
    var home = function () {
      if (!off()) return;
      var p = Math.round(strip.scrollLeft / w()), n = count();
      if (p <= 0) to(n); else if (p >= n + 1) to(1);
    };
    var thumbs = function () { return grail ? [].slice.call(grail.querySelectorAll('[data-pgal-t]')) : []; };
    var mark = function (i) {
      cur = i;
      main.setAttribute('data-at', i);   /* which photograph is in view: a product's light-mode tint stands aside for a studio first photograph */
      var ts = thumbs();
      ts.forEach(function (b, k) {
        b.classList.toggle('is-on', k === i);
        if (k === i) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
      });
      var t = ts[i];
      if (!t || !grail) return;
      var rr = grail.getBoundingClientRect(), tr = t.getBoundingClientRect();
      if (tr.left < rr.left || tr.right > rr.right) grail.scrollBy({ left: tr.left - rr.left - (rr.width - tr.width) / 2, behavior: reduce ? 'auto' : 'smooth' });
    };
    /* a frame held back (later) takes its photograph as data-src, set by wake() */
    var slide = function (src, alt, i, later) {
      var im = document.createElement('img');
      if (later) im.setAttribute('data-src', src); else im.src = src;
      im.alt = alt || ''; im.decoding = 'async';
      if (i > 1) im.loading = 'lazy';
      return im;
    };
    var woke = true;
    var wake = function () {
      if (woke) return;
      woke = true;
      [].forEach.call(strip.querySelectorAll('img[data-src]'), function (im) { im.src = im.getAttribute('data-src'); im.removeAttribute('data-src'); });
    };
    var fill = function (bigs, name) {
      strip.innerHTML = '';
      bigs.forEach(function (b, i) { strip.appendChild(slide(b, name ? name + ', photograph ' + (i + 1) + ' of ' + bigs.length : '', i)); });
      loop(); aim = -1; to(off()); mark(0);
    };
    var first = main.querySelector('img');
    var ts = thumbs();
    var bigs = ts.map(function (b) { return b.getAttribute('data-big'); }).filter(Boolean);
    main.appendChild(strip);
    if (first && (!bigs.length || first.getAttribute('src') === bigs[0])) {
      strip.appendChild(first);   /* the first photograph stays as the page drew it, already loading */
      /* the others wait until the page has loaded, or until a hand reaches for the strip or the rail, so nothing competes with
         the first, the page's largest paint */
      woke = false;
      bigs.slice(1).forEach(function (b, i) { strip.appendChild(slide(b, ts[i + 1].getAttribute('aria-label'), i + 1, true)); });
      loop(); to(off());
      var soon = function () { if ('requestIdleCallback' in window) window.requestIdleCallback(wake, { timeout: 1500 }); else window.setTimeout(wake, 600); };
      if (document.readyState === 'complete') soon(); else window.addEventListener('load', soon);
      ['pointerdown', 'wheel', 'keydown', 'focus'].forEach(function (ev) { strip.addEventListener(ev, wake, { passive: true }); });
      if (grail) ['pointerdown', 'keydown', 'focusin', 'click'].forEach(function (ev) { grail.addEventListener(ev, wake, { passive: true }); });
    } else if (bigs.length) {
      if (first) first.parentNode.removeChild(first);
      fill(bigs, '');
    }
    strip.addEventListener('scroll', function () {
      clearTimeout(rest); rest = setTimeout(home, 140);   /* rest, where a browser has no scrollend yet */
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        var n = count();
        if (!n) return;
        var i = ((Math.round(strip.scrollLeft / w()) - off()) % n + n) % n;   /* a copy counts as the photograph it shows */
        if (aim >= 0) { if (i !== aim) return; aim = -1; }   /* a thumbnail's glide passes the ones between without marking them */
        if (i !== cur) mark(i);
      });
    }, { passive: true });
    strip.addEventListener('scrollend', home);
    ['pointerdown', 'wheel', 'keydown'].forEach(function (ev) { strip.addEventListener(ev, function () { aim = -1; }, { passive: true }); });
    if (grail) grail.addEventListener('click', function (e) {
      var i = thumbs().indexOf(e.target.closest ? e.target.closest('[data-pgal-t]') : null);
      if (i < 0) return;
      aim = i; mark(i);
      strip.scrollTo({ left: (i + off()) * w(), behavior: reduce ? 'auto' : 'smooth' });
    });
    if ('ResizeObserver' in window) new ResizeObserver(function () { to(cur + off()); }).observe(strip);
    return { fill: fill };
  }
  var platform = null;
  [].forEach.call(root.querySelectorAll('.ti-pgal'), function (g) {
    var api = gallery(g);
    if (g.contains(root.querySelector('[data-pgal-rail]'))) platform = window.tiPlatform = api;
  });
})();
